import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Topbar from "../../components/Topbar/Topbar";
import { Search_icon, delete_icon_noti } from "../../assets/img";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { deletes } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";
import DateRange from "../../components/DateRange/DateRange";
import moment from "moment";

const UserTemplateNotification = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Send");
  const [templateOptions, setTemplateOptions] = useState([]);
  const [sentList, setSentList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [selectedFilter, setSelectedFilter] = useState({
    from: "",
    to: "",
    send_all: false
  });
  
  const [locationList, setLocationsList] = useState({
    states: [],
    cities: [],
  });
  const [serviceTypes, setServiceTypes] = useState([]);

  const [templateFilter, setTemplateFilter] = useState(null);
  const [stateFilter, setStateFilter] = useState(null);
  const [cityFilter, setCityFilter] = useState(null);
  const [serviceTypeFilter, setServiceTypeFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    id: null,
  });

  const handleSendNotifications = async (id = null) => {
    if (!checkPermission("CAN-ADD-NOTIFICATION")) return;

    let ids = [];
    if (id) {
      ids = [id];
    } else {
      ids = sentList.map(item => item.id);
    }
    
    if (ids.length === 0) {
      toast.warning("No notifications available to send.");
      return;
    }
    
    const payload = {
      notification_ids: ids,
    };

    try {
      const res = await post(URLS.SEND_NOTIFICATIONS, payload);
      if (res?.status === "success" || res?.status === true) {
        toast.success(res?.message || "Notifications sent successfully");
        fetchSentList();
      } else {
        toast.error(res?.message || "Failed to send notifications");
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to send notifications");
    }
  };

  const fetchSentList = async () => {
    try {
      const payload = {
        notification_status: activeTab === "Send" ? 1 : 2,
      };
      
      if (selectedFilter.from && selectedFilter.to) {
        payload.from_date = moment(selectedFilter.from).format("YYYY-MM-DD");
        payload.to_date = moment(selectedFilter.to).format("YYYY-MM-DD");
      }
      
      if (templateFilter?.value) payload.template_id = templateFilter.value;
      if (stateFilter?.value) payload.state_ids = stateFilter.value;
      if (cityFilter?.value) payload.city_ids = cityFilter.value;
      if (serviceTypeFilter?.value) payload.service_id = serviceTypeFilter.value;
      if (statusFilter?.value) payload.status = statusFilter.value;
      
      const res = await post(`${URLS.USER_TEMPLATE_SEND_NOTIFICATION_LIST}?page=${page}`, payload);
      if (res?.status === "success" || res?.data) {
        const results = Array.isArray(res?.data) ? res.data : (res?.results || res || []);
        
        setTotalPages(res?.total_pages || 1);
        setTotalCount(res?.count || results.length);

        setSentList(results);
      }
    } catch (error) {
      console.error("Error fetching sent list", error);
    }
  };

  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${parent_id ? `&parent_id=${parent_id}` : ""}`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({ value: item.id, label: item.name }));
      if (type === 2) setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      else if (type === 3) setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const getServiceTypes = async () => {
    try {
      const res = await get(URLS.SERVICESLIST_DROPDOWN);
      if (res?.status === "success" || res?.data) {
        const results = Array.isArray(res?.data) ? res.data : (res?.results || res || []);
        setServiceTypes(results.map(item => ({ value: item.id, label: item.name })));
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const res = await get(URLS.USER_NOTIFICATION_TEMPLATE_SEARCH_LIST);
        if (res?.status === "success" || res?.data) {
          const results = Array.isArray(res?.data) ? res.data : (res?.results || res || []);
          const options = (Array.isArray(results) ? results : []).map(item => ({
            value: item.id,
            label: item.name,
            data: item
          }));
          setTemplateOptions(options);
        }
      } catch (error) {
        console.error("Error fetching templates", error);
      }
    };

    fetchTemplates();
    getLocationsList(2);
    getServiceTypes();
  }, []);

  useEffect(() => {
    fetchSentList();
  }, [
    page, 
    selectedFilter.from, 
    selectedFilter.to, 
    selectedFilter.send_all,
    templateFilter,
    stateFilter,
    cityFilter,
    serviceTypeFilter,
    statusFilter,
    activeTab
  ]);

  const handleDeleteClick = (id) => {
    if (!checkPermission("CAN-DELETE-NOTIFICATION")) return;
    setDeleteConfirm({ open: true, id });
  };

  const handleDeleteConfirm = async () => {
    const { id } = deleteConfirm;
    setDeleteConfirm({ open: false, id: null });

    let res = await deletes(`${URLS.NOTIFICATION_SEND_DELETE}${id}/delete/`);
    if (res?.status === "success") {
      toast.success("Notification Deleted Successfully");
      fetchSentList();
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirm({ open: false, id: null });
  };

  return (
    <div className="layout_body p-3" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <div className="d-flex align-items-center justify-content-between header mb-3">
        <h2 className="mt-0 mb-0 ms-2 fw-bold" style={{ fontSize: "24px", color: "#000" }}>
          Notification User Template
        </h2>
        <Topbar />
      </div>

      <div className="mt-3 p-3 p-md-4 mb-4 mx-2" style={{ backgroundColor: "#f4f5f6", borderRadius: "16px" }}>
        
        {/* Top Controls Row */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
          {/* Tabs */}
          <div className="d-flex bg-white p-1" style={{ borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
            <button
              className={`btn px-4 py-2 ${activeTab === "Send" ? "text-white" : "text-muted"}`}
              style={{
                backgroundColor: activeTab === "Send" ? "#b863f8" : "transparent",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "14px",
                border: "none",
              }}
              onClick={() => setActiveTab("Send")}
            >
              Send
            </button>
            <button
              className={`btn px-4 py-2 ${activeTab === "Sent" ? "text-white" : "text-muted"}`}
              style={{
                backgroundColor: activeTab === "Sent" ? "#b863f8" : "transparent",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "14px",
                border: "none",
              }}
              onClick={() => setActiveTab("Sent")}
            >
              Sent
            </button>
          </div>

          {/* Search */}
          <div className="search-box position-relative flex-grow-1" style={{ maxWidth: "300px" }}>
            <img src={Search_icon} alt="search" className="position-absolute top-50 start-0 translate-middle-y ms-3" style={{ width: '18px', opacity: 0.5, zIndex: 10 }} />
            <Select
              placeholder="Search Teamplate Name"
              options={templateOptions}
              onChange={(selected) => {
                if (selected) {
                  navigate("/send-template-notification", { state: { template: selected.data } });
                }
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "8px",
                  border: "1px solid #e8e8e8",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                  minHeight: "38px",
                  paddingLeft: "35px",
                  boxShadow: "none"
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: "0"
                })
              }}
            />
          </div>

          {/* Date Ranges & Send All */}
          <div className="d-flex gap-3 align-items-center flex-wrap">
            {activeTab === "Sent" && (
              <DateRange
                setFromDate={(date) => handleChangeFilter("from", date)}
                setToDate={(date) => handleChangeFilter("to", date)}
              />
            )}


          </div>
        </div>

        {/* Dropdowns Row */}
        <div className="d-flex flex-wrap gap-3 mb-4">
          <Select
            className="flex-grow-1"
            options={templateOptions}
            value={templateFilter}
            onChange={(selected) => {
              setTemplateFilter(selected);
              setPage(1);
            }}
            isClearable
            placeholder="Template Name"
            styles={{ control: (base) => ({ ...base, borderRadius: "8px", minWidth: "150px" }) }}
          />
          <Select
            className="flex-grow-1"
            options={locationList?.states}
            value={stateFilter}
            onChange={(selected) => {
              setLocationsList(prev => ({ ...prev, cities: [] }));
              if (selected?.value) getLocationsList(3, selected.value);
              setStateFilter(selected);
              setCityFilter(null);
              setPage(1);
            }}
            isClearable
            placeholder="State"
            styles={{ control: (base) => ({ ...base, borderRadius: "8px", minWidth: "150px" }) }}
          />
          <Select
            className="flex-grow-1"
            options={locationList?.cities}
            value={cityFilter}
            onChange={(selected) => {
              setCityFilter(selected);
              setPage(1);
            }}
            isClearable
            placeholder="City"
            styles={{ control: (base) => ({ ...base, borderRadius: "8px", minWidth: "150px" }) }}
          />
          <Select
            className="flex-grow-1"
            options={serviceTypes}
            value={serviceTypeFilter}
            onChange={(selected) => {
              setServiceTypeFilter(selected);
              setPage(1);
            }}
            isClearable
            placeholder="Service type"
            styles={{ control: (base) => ({ ...base, borderRadius: "8px", minWidth: "150px" }) }}
          />
          <Select
            className="flex-grow-1"
            options={[
              { label: "Notification Sent", value: "Notification Sent" },
              { label: "Pending", value: "Pending" },
              { label: "Failed", value: "Failed" }
            ]}
            value={statusFilter}
            onChange={(selected) => {
              setStatusFilter(selected);
              setPage(1);
            }}
            isClearable
            placeholder="Status"
            styles={{ control: (base) => ({ ...base, borderRadius: "8px", minWidth: "150px" }) }}
          />
        </div>

        {/* Table Styles */}
        <style>
          {`
            .nt-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0 10px;
            }
            .nt-table thead th {
              border: none;
              font-weight: 600;
              color: #4a4a4a;
              font-size: 13px;
              padding: 12px 16px;
              text-align: left;
            }
            .nt-table tbody tr {
              background-color: #ffffff;
              box-shadow: 0 1px 3px rgba(0,0,0,0.02);
            }
            .nt-table tbody td {
              border-top: none;
              border-bottom: none;
              padding: 16px;
              vertical-align: middle;
              font-size: 13px;
              color: #555;
            }
            .nt-table tbody td:first-child { border-top-left-radius: 8px; border-bottom-left-radius: 8px; }
            .nt-table tbody td:last-child { border-top-right-radius: 8px; border-bottom-right-radius: 8px; }
            
            .action-icon-btn {
              background-color: #f8edff;
              color: #b863f8;
              border: none;
              border-radius: 50%;
              width: 32px;
              height: 32px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              margin-left: 8px;
            }
          `}
        </style>

        {/* Table Area */}
        <div className="table-responsive">
          <table className="nt-table">
            <thead>
              <tr>
                <th className="text-center">S.No</th>
                <th>Teamplate Name</th>
                <th>Created By</th>
                <th>State</th>
                <th>City</th>
                <th>Send Date</th>
                <th>Send Time</th>
                <th className="text-center" style={{ minWidth: "250px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {sentList && sentList.length > 0 ? (
                sentList.map((item, index) => (
                  <tr key={item.id || index}>
                    <td className="text-center">{String((page - 1) * 10 + index + 1).padStart(2, '0')}</td>
                    <td>{item.template_name || item.title || "N/A"}</td>
                    <td>{item.created_by_name || item.created_admin_by || "Admin"}</td>
                    <td>
                      {item.states && item.states.length > 0
                        ? item.states.slice(0, 2).join(" | ") + (item.states.length > 2 ? " +" : "")
                        : "All"}
                    </td>
                    <td>
                      {item.cities && item.cities.length > 0
                        ? item.cities.slice(0, 2).join(" | ") + (item.cities.length > 2 ? " +" : "")
                        : "All"}
                    </td>
                    <td>{item.notification_date || "-"}</td>
                    <td>{item.notification_time || "-"}</td>
                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center">
                        {activeTab === "Send" && checkPermission("CAN-ADD-NOTIFICATION") && (
                          <button 
                            onClick={() => handleSendNotifications(item.id)}
                            className="btn text-white"
                            style={{ backgroundColor: "#b863f8", borderRadius: "6px", fontSize: "12px", fontWeight: "600", padding: "8px 16px", whiteSpace: "nowrap", flexShrink: 0, marginRight: "4px" }}
                          >
                            Send Notification
                          </button>
                        )}
                        
                        {checkPermission("CAN-EDIT-NOTIFICATION") && (
                          <button 
                            className="action-icon-btn"
                            onClick={() => navigate("/send-template-notification", { state: { type: "edit", data: item } })}
                          >
                            <EditIcon style={{ fontSize: "16px" }} />
                          </button>
                        )}
                        {checkPermission("CAN-VIEW-NOTIFICATION") && (
                          <button 
                            className="action-icon-btn"
                            onClick={() => navigate("/send-template-notification", { state: { type: "view", data: item } })}
                          >
                            <VisibilityIcon style={{ fontSize: "16px" }} />
                          </button>
                        )}
                        {checkPermission("CAN-DELETE-NOTIFICATION") && (
                          <button 
                            className="action-icon-btn"
                            onClick={() => handleDeleteClick(item.id)}
                          >
                            <DeleteIcon style={{ fontSize: "16px" }} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-muted py-4">No notifications found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>

      <div className="d-flex justify-content-center align-items-center mt-5 pb-5" style={{ gap: "20px", fontSize: "14px" }}>
         <span 
           className="cursor-pointer" 
           style={{ color: page > 1 ? "#333" : "#d1c6db", fontWeight: "500", pointerEvents: page > 1 ? "auto" : "none" }}
           onClick={() => page > 1 && setPage(page - 1)}
         >
           &lt;&lt; Previous
         </span>
         
         {[...Array(totalPages)].map((_, i) => {
           const pageNum = i + 1;
           if (
             pageNum === 1 || 
             pageNum === totalPages || 
             (pageNum >= page - 1 && pageNum <= page + 1)
           ) {
             return (
               <span 
                 key={pageNum}
                 className="cursor-pointer" 
                 style={{ 
                   color: page === pageNum ? "#c175ff" : "#6c757d", 
                   fontWeight: page === pageNum ? "600" : "normal" 
                 }}
                 onClick={() => setPage(pageNum)}
               >
                 {pageNum}
               </span>
             );
           } else if (
             pageNum === page - 2 || 
             pageNum === page + 2
           ) {
             return <span key={pageNum} className="text-muted">....</span>;
           }
           return null;
         })}

         <span 
           className="cursor-pointer" 
           style={{ color: page < totalPages ? "#333" : "#d1c6db", fontWeight: "500", pointerEvents: page < totalPages ? "auto" : "none" }}
           onClick={() => page < totalPages && setPage(page + 1)}
         >
           Next <span style={{ color: page < totalPages ? "#c175ff" : "#d1c6db" }}>&gt;&gt;</span>
         </span>
      </div>

      {deleteConfirm.open && (
        <div className="img-popup-design" style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999
        }}>
          <div className="img-popup" style={{
            backgroundColor: "#fff",
            padding: "24px",
            borderRadius: "16px",
            maxWidth: "400px",
            width: "90%",
            textAlign: "center"
          }}>
            <h2 className="f4 mt-2 mb-3" style={{ fontSize: "20px", fontWeight: "bold" }}>
              Delete Notification
            </h2>
            <p className="f3 mb-4" style={{ color: "#555", fontSize: "14px" }}>
              Are you sure you want to delete this Notification? This action
              cannot be undone.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <button 
                onClick={handleDeleteCancel} 
                className="btn px-4 py-2"
                style={{
                  backgroundColor: "#f5e6ff",
                  color: "#b863f8",
                  border: "1px solid #e1c5f9",
                  borderRadius: "8px",
                  fontWeight: "600"
                }}
              >
                No, Cancel
              </button>
              <button 
                onClick={handleDeleteConfirm} 
                className="btn px-4 py-2 text-white"
                style={{
                  backgroundColor: "#b863f8",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600"
                }}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserTemplateNotification;
